<template>
    <div class="approvalStatus-list">
        <el-row>
            <el-steps v-if="approvalDetail.approvalMethod != 2 && approvalDetail.approvalTotalNum>0" align-center finish-status="success">
                <el-step v-for="(item, index) in approvalDetail.users" :class="activeClass(item)" :key="index" :title="item.trueName" :description="item.hasOwnProperty('description')?item.description:''"></el-step>
            </el-steps>
            <el-steps v-if="approvalDetail.approvalMethod == 2 && approvalDetail.approvalTotalNum>0" align-center finish-status="success">
                <el-step v-for="(item, index) in approvalDetail.approVoList" :class="activeClass(item)" :key="index" align-center :description="item.hasOwnProperty('description')?item.description:''">
                    <el-breadcrumb v-if="item && item.list.length > 0" slot="title" :separator="(approvalDetail.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                        <el-breadcrumb-item  v-for="(user, i) in item.list" :key="i" :class="activeUserClass(user)">{{user.trueName}}</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-step>
            </el-steps>
        </el-row>
    </div>
</template>

<script>
    export default {
        data () {
            return {
            };
        },
        props: {
            approvalDetail: { // 列表数据
                type: Object
            }
        },
        created () {
    
        },
        methods: {
            activeClass (item) {
                if (item.stepStatus === 1) {
                    return 'success-step';
                } else if (item.stepStatus === 2) {
                    return 'reject-step';
                } else if (item.stepStatus === 99) {
                    return 'now-step';
                } else {
                    return '';
                }
            },
            activeUserClass (item) {
                if (item.stepStatus === 1) {
                    return 'success-user';
                } else if (item.stepStatus === 2) {
                    return 'reject-user';
                } else if (item.stepStatus === 99) {
                    return 'now-user';
                } else {
                    return '';
                }
            }
        }
    };
</script>

<style lang="less">
    .approvalStatus-list {
        .el-step__main .el-breadcrumb{
            display: inline-block;
        }
        .success-step{
          .el-step__head{
              color: #67c23a;
              border-color: #67c23a; 
              .is-success{
                color: #67c23a;
                border-color: #67c23a; 
              }
          }
          .el-breadcrumb__inner{
                color: #c0c4cc;
                .is-success{
                    color: #67c23a;
                    border-color: #67c23a; 
                }
           }
           .success-user .el-breadcrumb__inner{
               color: #67c23a;
           }
          .el-step__title{
              color: #67c23a;
          }
          .el-step__description{
              color: #303133;
          }
          .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #67c23a;
            color: #67c23a;
          }
        }
        .reject-step{
          .el-step__head{
              color: #f56c6c;
              border-color: #f56c6c; 
          }
           .el-breadcrumb__inner{
                color: #c0c4cc;
           }
           .reject-user .el-breadcrumb__inner{
               color: #f56c6c;
           }
          .el-step__title{
              color: #f56c6c;
          }
          .el-step__description{
              color: #303133;
          }
        }
        .now-step{
          .el-step__head{
              color: #409eff;
              border-color: #409eff; 
              .is-success{
                color: #409eff;
                border-color: #409eff; 
              }
          }
          .el-breadcrumb__inner{
                color: #409eff;
                border-color: #409eff; 
                .is-success{
                    color: #409eff;
                    border-color: #409eff; 
                }
            }
          .el-step__title{
              color: #409eff;
              .is-process{
                font-weight: 700;
              }
          }
          .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #409eff;
            color: #409eff;
          }
        }
        .success-user .el-breadcrumb__inner{
            color: #67c23a;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DynamicTable/DynamicApprovalPop.vue